// extracted by mini-css-extract-plugin
export default {"rankBoard":"Rank_rankBoard__OVWsO","note":"Rank_note__QgX6X"};